<template>
  <div class="k-recipe-modal" v-scroll-stop>
    <go-back class="k-recipe-modal__goback mb-2 px-3" text="Назад к списку покупок" @click="$emit('close')"/>
    <div class="position-relative">
      <img v-if="image" class="k-recipe-modal__image" :src="recipe.cover_full_url" alt="img">
      <div class="k-recipe-modal__badge-text k-recipe-modal__badge--absolute cursor-pointer d-flex d-md-none">
        {{ guestCount }} {{ declOfNum(guestCount, ['порция','порции','порций']) }}
      </div>
    </div>
    <div class="k-recipe-modal__content p-5">
      <p class="k-recipe-modal__day-title my-2">
        {{ dateFormat(recipe.date, 'dddd') }}
        <span style="font-weight: 400">{{ dateFormat(recipe.date, 'dd mmm') }}</span>
      </p>
      <div class="d-flex align-items-center">
        <p class="k-recipe-modal__title my-2 mr-3">{{ recipe.title }}</p>
        <span class="k-recipe-modal__badge-text cursor-pointer d-none d-md-flex">
          {{ guestCount }} {{ declOfNum(guestCount, ['порция','порции','порций']) }}
        </span>
      </div>
      <div class="k-recipe__warning k-recipe__warning--orange col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height">
        <div class="k-recipe__warning-text">
          <h2>Внимание!</h2>
          <p>Указан вес очищенных и подготовленных продуктов</p>
        </div>
      </div>
      <div
        key="show-boughted-top"
        class="k-purchases__toggle-boughted k-ingredient-card-transition"
        :class="{ active: allIngredientsAreVisible }"
        @click="allIngredientsAreVisible ^= true"
      >{{ !allIngredientsAreVisible ? 'Показать купленные' : 'Скрыть купленные' }}</div>
      <transition-group name="list-complete" tag="div" class="k-purchases__content">
        <div v-for="item in recipe.ingredients" :key="item.id" class="k-ingredient-card k-ingredient-card-transition">
          <purchase-card
            :item="{...item}"
            currentTab="recipes"
            :recipe="recipe"
            @bought="value => setIsBought(item, value)"
            :date="recipe.date || recipe.meal.date"
            v-show="item.is_bought === 'f' || allIngredientsAreVisible"
          />
        </div>
      </transition-group>
      <div
        key="show-boughted"
        class="k-purchases__toggle-boughted k-ingredient-card-transition"
        :class="{ active: allIngredientsAreVisible }"
        @click="allIngredientsAreVisible ^= true"
      >{{ !allIngredientsAreVisible ? 'Показать купленные' : 'Скрыть купленные' }}</div>
    </div>
  </div>
</template>

<script>
import GoBack from '../../components/TheGoBack';
import PurchaseCard from '../../components/PurchaseCard.vue';
import dateFormat from '../../utils/dateformat';
import { declOfNum } from '../../utils/helper';

export default {
  components: {
    GoBack,
    PurchaseCard
  },
  props: {
    recipe: Object,
    image: Boolean,
  },
  data: () => ({
    allIngredientsAreVisible: false,
    dateFormat,
    declOfNum,
  }),
  methods: {
    setIsBought(item, value) {
      this.$set(item, "is_bought", value);
      this.$forceUpdate();
    },
  },
  computed: {
    guestCount() {
      return this.recipe.number_of_servings + this.recipe.guest_count
    }
  }
}
</script>

<style lang="scss" scoped>
.k-recipe-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 90px 40px 0;
  overflow-y: scroll;
  z-index: 2;

  &__content {
    background: #FFFFFF;
    border: 1px solid #EBEBEB;
    box-sizing: border-box;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    padding: 20px;
  }
}
.k-recipe-modal__image {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
}
.k-recipe-modal__goback {
  height: 70px;
}
.k-recipe-modal__title {
  font-weight: 600;
  font-size: 17px;
  color: #616161;
}
.k-recipe-modal__day-title {
  font-size: 20px;
  font-weight: 600;
  color: #616161;
}
.k-recipe-modal__badge {
  font-size: 14px;
  border-radius: 12px;
  background: #F68C1E;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #FFFFFF;
  padding: 0 12px;
  max-height: 25px;
  text-align: center;

  &--absolute {
    width: 130px;
    height: 36px;
    position: absolute;
    text-align: center;
    bottom: 5%;
    right: 5%;
    max-height: unset;
  }
}
.k-menu__dish-actions {
  align-items: center;
}
.k-menu__portions {
  font-size: 11px;
  line-height: 1.1;
  text-align: center;
  color: #F68C1E;

  span {
    &:first-child {
      font-size: 17px;
    }
  }
}
@media (max-width: 767.98px) {
  .k-ingredient-card {
    margin-right: 0;
    width: 100%;
  }
  .k-purchase__title-description {
    flex-direction: column;
  }
  .k-recipe-modal {
    padding: 90px 0 0;

    &__content {
      padding: 10px !important;
    }
  }
}


.k-ingredient-card-transition {
  transition: all 0.5s;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.k-recipe-modal__badge-text {
  font-size: 14px;
  padding: 0 12px;
  align-items: center;
  justify-content: center;
}
</style>
